export type Movie = {
  id: string;
  title: string;
  original: string;
  year: string;
  region: string;
  genres: string[];
  stars: number;
  blurb: string;
  image: string;
};

export const movieRegions = ["全部", "华语", "欧美", "日韩"];

export const movieGenres = ["全部", "剧情", "科幻", "犯罪", "动画", "喜剧", "奇幻"];

export const movies: Movie[] = [
  {
    id: "m01",
    title: "肖申克的救赎",
    original: "The Shawshank Redemption",
    year: "1994",
    region: "欧美",
    genres: ["剧情", "犯罪"],
    stars: 5,
    blurb: "以希望与坚持为核心的长线叙事剧情片，节奏沉稳、情绪层层递进，适合喜欢慢热与人物刻画的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20lone%20figure%20silhouetted%20in%20a%20rain%20soaked%20stone%20courtyard%20under%20warm%20breaking%20light%2C%20muted%20amber%20and%20charcoal%20palette%2C%20dramatic%20chiaroscuro%2C%20subtle%20film%20grain%2C%20minimalist%20premium%20composition&width=600&height=900&seq=sm-poster-01&orientation=portrait",
  },
  {
    id: "m02",
    title: "霸王别姬",
    original: "Farewell My Concubine",
    year: "1993",
    region: "华语",
    genres: ["剧情"],
    stars: 5,
    blurb: "横跨数十年时代变迁的华语剧情代表作，以舞台与人生的交织见长，适合偏爱人文厚度与表演张力的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20traditional%20opera%20stage%20curtain%20with%20a%20single%20warm%20spotlight%2C%20muted%20amber%20crimson%20and%20charcoal%20palette%2C%20soft%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20minimalist%20composition&width=600&height=900&seq=sm-poster-02&orientation=portrait",
  },
  {
    id: "m03",
    title: "千与千寻",
    original: "Spirited Away",
    year: "2001",
    region: "日韩",
    genres: ["动画", "奇幻"],
    stars: 5,
    blurb: "以奇幻世界为背景的动画长片，世界观设定细腻、想象力充沛，适合家庭观看与喜欢手绘动画风格的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20glowing%20lantern%20lit%20night%20street%20with%20warm%20mist%2C%20muted%20amber%20and%20charcoal%20palette%2C%20dreamy%20soft%20lighting%2C%20subtle%20film%20grain%2C%20whimsical%20minimalist%20composition&width=600&height=900&seq=sm-poster-03&orientation=portrait",
  },
  {
    id: "m04",
    title: "盗梦空间",
    original: "Inception",
    year: "2010",
    region: "欧美",
    genres: ["科幻", "犯罪"],
    stars: 5,
    blurb: "以多层梦境结构展开的科幻悬疑片，逻辑密度高、视觉设计独特，适合喜欢烧脑设定与反转叙事的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20collapsing%20city%20skyline%20folding%20into%20itself%20under%20warm%20haze%2C%20muted%20amber%20and%20steel%20charcoal%20palette%2C%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20bold%20minimalist%20composition&width=600&height=900&seq=sm-poster-04&orientation=portrait",
  },
  {
    id: "m05",
    title: "星际穿越",
    original: "Interstellar",
    year: "2014",
    region: "欧美",
    genres: ["科幻", "剧情"],
    stars: 5,
    blurb: "以星际探索与亲情为主线的科幻片，画面宏大、配乐突出，适合在意的视听体验与宇宙题材的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20tiny%20astronaut%20before%20a%20vast%20warm%20nebula%20and%20ringed%20planet%2C%20muted%20amber%20and%20deep%20charcoal%20palette%2C%20soft%20cosmic%20lighting%2C%20subtle%20film%20grain%2C%20epic%20minimalist%20composition&width=600&height=900&seq=sm-poster-05&orientation=portrait",
  },
  {
    id: "m06",
    title: "让子弹飞",
    original: "Let the Bullets Fly",
    year: "2010",
    region: "华语",
    genres: ["剧情", "喜剧"],
    stars: 4,
    blurb: "节奏明快、台词密集的华语类型片，戏剧冲突与黑色幽默并存，适合喜欢群像对手戏的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20dusty%20frontier%20town%20with%20warm%20hanging%20sunlight%20and%20flying%20dust%2C%20muted%20amber%20rust%20and%20charcoal%20palette%2C%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20striking%20minimalist%20composition&width=600&height=900&seq=sm-poster-06&orientation=portrait",
  },
  {
    id: "m07",
    title: "无间道",
    original: "Infernal Affairs",
    year: "2002",
    region: "华语",
    genres: ["剧情", "犯罪"],
    stars: 5,
    blurb: "华语犯罪题材的经典之作，双线人物设定紧张克制，适合偏好警匪博弈与精炼叙事的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20two%20shadowy%20figures%20back%20to%20back%20on%20a%20rainy%20rooftop%20at%20dusk%2C%20muted%20amber%20and%20cool%20charcoal%20palette%2C%20moody%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20taut%20minimalist%20composition&width=600&height=900&seq=sm-poster-07&orientation=portrait",
  },
  {
    id: "m08",
    title: "教父",
    original: "The Godfather",
    year: "1972",
    region: "欧美",
    genres: ["剧情", "犯罪"],
    stars: 5,
    blurb: "黑帮家族史诗的开山级作品，人物关系与群像塑造厚重，适合喜欢经典叙事结构与年代质感的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20dimly%20lit%20vintage%20study%20with%20a%20single%20warm%20desk%20lamp%20and%20heavy%20drapes%2C%20muted%20amber%20and%20deep%20brown%20charcoal%20palette%2C%20classic%20dramatic%20lighting%2C%20subtle%20film%20grain&width=600&height=900&seq=sm-poster-08&orientation=portrait",
  },
  {
    id: "m09",
    title: "阿甘正传",
    original: "Forrest Gump",
    year: "1994",
    region: "欧美",
    genres: ["剧情", "喜剧"],
    stars: 5,
    blurb: "以普通人视角串联时代变迁的温情剧情片，叙事娓娓道来，适合轻松又希望有所回味的观影场景。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20lone%20bench%20on%20a%20warm%20tree%20lined%20avenue%20at%20golden%20hour%2C%20muted%20amber%20and%20soft%20charcoal%20palette%2C%20gentle%20nostalgic%20lighting%2C%20subtle%20film%20grain%2C%20warm%20minimalist%20composition&width=600&height=900&seq=sm-poster-09&orientation=portrait",
  },
  {
    id: "m10",
    title: "流浪地球",
    original: "The Wandering Earth",
    year: "2019",
    region: "华语",
    genres: ["科幻", "剧情"],
    stars: 4,
    blurb: "华语硬科幻的代表性尝试之一，以灾难与家园主题展开，适合关注国产科幻发展与工业水准的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20frozen%20earth%20surface%20with%20glowing%20engines%20under%20a%20dim%20warm%20sky%2C%20muted%20amber%20ice%20blue%20and%20charcoal%20palette%2C%20cold%20dramatic%20lighting%2C%20subtle%20film%20grain&width=600&height=900&seq=sm-poster-10&orientation=portrait",
  },
  {
    id: "m11",
    title: "疯狂的石头",
    original: "Crazy Stone",
    year: "2006",
    region: "华语",
    genres: ["喜剧", "犯罪"],
    stars: 4,
    blurb: "多线交错的华语黑色喜剧，节奏轻快、巧合密集，适合想放松又想看结构巧思的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20cluttered%20old%20city%20alley%20with%20warm%20flickering%20neon%20reflections%2C%20muted%20amber%20teal%20and%20charcoal%20palette%2C%20playful%20dramatic%20lighting%2C%20subtle%20film%20grain&width=600&height=900&seq=sm-poster-11&orientation=portrait",
  },
  {
    id: "m12",
    title: "搏击俱乐部",
    original: "Fight Club",
    year: "1999",
    region: "欧美",
    genres: ["剧情", "犯罪"],
    stars: 4,
    blurb: "气质冷峻、结构反转的cult风格剧情片，主题偏思辨，适合喜欢讨论型与风格化叙事的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20poster%20art%20of%20a%20gritty%20underground%20basement%20with%20a%20single%20hot%20hanging%20bulb%20and%20haze%2C%20muted%20amber%20rust%20and%20charcoal%20palette%2C%20harsh%20dramatic%20lighting%2C%20subtle%20film%20grain&width=600&height=900&seq=sm-poster-12&orientation=portrait",
  },
];